import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import NewsListChild from "./NewsListChild";

const NewsList = () => {
  return (
    <MainTemplate>
        <NewsListChild />
    </MainTemplate>
  );
};

export default NewsList;
